import { type LoadServerCxModuleOptions } from '@cx-modules/client';
import { fetchOffersDeliveryApiData } from '@cx-modules/offers-delivery-api-service';

import { type LoadOffersSlimArgs } from '../../contract';

// This removed client helper resolved to the loader args without the separately supplied endpoint.
export type OffersRequestParams = Omit<LoadOffersSlimArgs, 'dataApiEndpoint'>;

export const fetchOffersSlimData = async (
  dataApiEndpoint = 'https://offers-delivery-api-stg.core.occloud.io', // Default to Stg if not provided
  params: OffersRequestParams,
  options: LoadServerCxModuleOptions | undefined = {},
) => {
  try {
    return await fetchOffersDeliveryApiData<OffersRequestParams>(dataApiEndpoint, params, options);
  } catch (error) {
    if (options.logger) {
      options.logger.error(error);
    }
    throw error;
  }
};

export const getOffersSlimCacheKey = ({
  apiKey,
  countryCode,
  offerIds,
  offerLimit,
  sortBy,
  subdivisionCode,
  vcId,
}: OffersRequestParams) => {
  const cacheKey = ['offers-slim', apiKey, offerIds, vcId, countryCode, subdivisionCode, offerLimit, sortBy];

  return cacheKey;
};
